import { notifyHandledException } from '../utils/errorLogger';

enum CartAction {
  INCREASE = 'increase',
  DECREASE = 'decrease',
}

interface LineItem {
  key: string;
  quantity: number;
  final_line_price: number;
}

interface ShopifyCartResponse {
  item_count: number;
  items: Array<LineItem>;
  items_subtotal_price: number;
}

type UpdateCartReqBody = Record<string, number>;

type CartUpdateCallback = (res: ShopifyCartResponse) => void;

export function initCartPageActions(): void {
  window.Shopify.money_format = '${{amount_no_decimals}}';
  attachEventHandlers();
}

function attachEventHandlers(): void {
  attachCartActionHandler(CartAction.INCREASE);
  attachCartActionHandler(CartAction.DECREASE);
  attachDeleteHandler();
}

function attachCartActionHandler(action: CartAction): void {
  $(`.cart-wrapper .cart__${action}-qty-btn`).on('click', (e) => {
    e.preventDefault();
    const itemRow = $(e.target).closest('.cart__row');
    const input = itemRow.find('.cart__qty-input');
    const currentQty = input.val();
    const lineItemKey = itemRow[0].dataset.key;

    if (!lineItemKey) return;

    updateCartItem(
      lineItemKey,
      Number(currentQty),
      action,
      (json: ShopifyCartResponse) => {
        updateCartInDOM(json, itemRow);
      },
      () => showCartUpdateErrorMessage(itemRow)
    );
  });
}

function attachDeleteHandler(): void {
  $('.cart-wrapper a.cart__remove').on('click', (e) => {
    e.preventDefault();
    const itemRow = $(e.target).closest('.cart__row');
    const lineItemKey = itemRow[0].dataset.key;

    if (!lineItemKey) return;

    deleteCartItem(
      lineItemKey,
      (cart: ShopifyCartResponse) => {
        itemRow.remove();
        if (cart.item_count === 0) {
          reloadPage();
        }
      },
      () => showCartUpdateErrorMessage(itemRow)
    );
  });
}

function updateCartItem(
  lineItemKey: string,
  currentQty: number,
  action: CartAction,
  successCb: CartUpdateCallback,
  failureCb: () => void
): void {
  let newQuantity;

  if (action === CartAction.INCREASE) {
    newQuantity = currentQty + 1;
  } else {
    newQuantity = currentQty - 1;
  }

  cartUpdateRequest({ [lineItemKey]: newQuantity }, successCb, failureCb);
}

function deleteCartItem(
  lineItemKey: string,
  successCb: CartUpdateCallback,
  failureCb: () => void
): void {
  cartUpdateRequest({ [lineItemKey]: 0 }, successCb, failureCb);
}

function cartUpdateRequest(
  updatedData: UpdateCartReqBody,
  successCb: CartUpdateCallback,
  failureCb: () => void
): void {
  fetch(`${window.Shopify.routes.root}cart/update.js`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      updates: updatedData,
    }),
  })
    .then((response) => {
      if (!response.ok) {
        failureCb();
      }
      return response.json();
    })
    .then((json) => successCb(json))
    .catch((err) => {
      failureCb();
      notifyHandledException(err);
    });
}

function updateCartInDOM(
  cart: ShopifyCartResponse,
  itemRow: JQuery<HTMLElement>
): void {
  const qtyInput = itemRow.find('.cart__qty-input');
  const priceEl = itemRow.find('.cart__price-wrapper span');
  const lineItemKey = itemRow[0].dataset.key;
  const updatedItem = cart.items.find((item) => item.key == lineItemKey);
  const itemCountEls = $('span.cart-item-count');
  const subtotalEl = $('.cart__actions .cart__subtotal');
  const itemsEl = $('.cart__actions .cart-items-text');

  if (!updatedItem) {
    itemRow.remove();
    if (cart.item_count === 0) reloadPage();
  } else {
    qtyInput.attr('value', updatedItem.quantity);
    priceEl.text(window.Shopify.formatMoney(updatedItem.final_line_price));
  }

  itemCountEls?.text(cart.item_count);
  itemsEl.text(cart.item_count === 1 ? 'item' : 'items');
  subtotalEl?.text(window.Shopify.formatMoney(cart.items_subtotal_price));
}

function reloadPage(): void {
  window.location.reload();
}

function showCartUpdateErrorMessage(itemRow: JQuery<HTMLElement>): void {
  const wrapper = itemRow.closest('.cart__row-wrapper');

  if (wrapper.find('.cart__error-message').length > 0) return;

  const errorMessage = 'Could not update cart item. Please try again!';
  const errorEl = document.createElement('div');

  errorEl.classList.add('cart__error-message');
  errorEl.textContent = errorMessage;
  wrapper.append(errorEl);
  window.setTimeout(() => {
    $(errorEl).fadeOut(300, function () {
      $(this).remove();
    });
  }, 3000);
}
